// Main entry point that routes to button or widget based on build target
const buildTarget = process.env.REACT_APP_BUILD_TARGET;

if (buildTarget === 'button') {
  // Load button entry point
  import('./button/index');
} else {
  // Default to widget entry point
  import('./widget/index');
}

// Make this a module
export { };

